import * as React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  Checkbox,
  Tabs,
  Tab,
  Stack,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PrintIcon from "@mui/icons-material/Print";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import configServ from "../../services/config";
import { useDispatch } from "react-redux";
import { triggerLoader } from "../../redux/reducers/LoaderTrigger";
import AlertDialog from "../../Components/AlertDialog/AlertDialog";

// ✅ Tab Panel
function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

export default function VoucherOrientation({ open, setOpen, data }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [page, setPage] = useState(2);
  const [tabValue, setTabValue] = useState(0);
  const [isEmail, setIsEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log("data", data);

  const dispatch = useDispatch();

  const handleOpenDialog = (content) => {
    setDialogContent(content);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogContent("");
  };

  const fetchCustomerEmail = async () => {
    try {
      setLoading(true);
      const dataToSend = { customer_id: data.customer_id };
      const res = await configServ.getCustomerEmailByID(dataToSend);
      if (res.status === 200) {
        setIsEmail(true);
      } else {
        setIsEmail(false);
      }
    } catch (e) {
      console.log(e);
      setIsEmail(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchCustomerEmail();
    }
  }, [open]);

  const printVoucher = async (landscape, sendEmail = false) => {
    dispatch(triggerLoader());
    try {
      const dataToSend = {
        ...data,
        landscape: landscape,
        page: page,
        sendEmail: sendEmail,
      };

      const result = await configServ.printVoucher(dataToSend);

      if (!sendEmail) {
        // Agar sirf print karna ho
        const base64String = result.file;
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = result.filename || "voucher.pdf"; // 👈 backend se aaya hua filename use kare
        link.click();
      } else {
        handleOpenDialog("Voucher has been sent to customer email!");
      }
    } catch (e) {
      handleOpenDialog("Error while processing voucher");
      console.log(e);
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePage = (event) => {
    const data = parseInt(event.target.value);
    setPage(data);
  };

  return (
    <div>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title="Alert"
        message={dialogContent}
        buttonTitle="Ok"
      />

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
              <Tab label="EMAIL" sx={{ fontWeight: 600 }} />
              <Tab label="PRINT" sx={{ fontWeight: 600 }} />
            </Tabs>
          </Box>
          <Box position="absolute" right={16} top={6}>
            <IconButton onClick={handleClose}>
              <DisabledByDefaultIcon sx={{ fontSize: 32 }} color="error" />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* EMAIL TAB */}
        <TabPanel value={tabValue} index={0}>
          <Box textAlign="center">
            <Typography variant="h6" color="textSecondary">
              Save paper, send the voucher via email!
            </Typography>
            <br />
            <Button
              disabled={!isEmail || loading}
              variant="contained"
              color="primary"
              startIcon={<EmailIcon />}
              onClick={() => {
                handleClose();
                printVoucher(false, true); // 👈 email send true
              }}
            >
              Send Email
            </Button>
            {!loading && !isEmail && (
              <Typography color="error" mt={2}>
                No email address found. Please update customer email.
              </Typography>
            )}
          </Box>
        </TabPanel>

        {/* PRINT TAB */}
        <TabPanel value={tabValue} index={1}>
          <Box mb={2}>
            <FormControl>
              <FormLabel sx={{ color: "#090e34" }}>No. of pages</FormLabel>
              <RadioGroup row value={page} onChange={handlePage}>
                <FormControlLabel value={1} control={<Radio />} label="1" />
                <FormControlLabel value={2} control={<Radio />} label="2" />
                <FormControlLabel value={3} control={<Radio />} label="3" />
                <FormControlLabel value={4} control={<Radio />} label="4" />
              </RadioGroup>
            </FormControl>
          </Box>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              variant="contained"
              startIcon={<PrintIcon />}
              onClick={() => {
                handleClose();
                printVoucher(true, false); // landscape print
              }}
            >
              Landscape
            </Button>
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={() => {
                handleClose();
                printVoucher(false, false); // portrait print
              }}
            >
              Portrait
            </Button>
          </DialogActions>
        </TabPanel>
      </Dialog>
    </div>
  );
}
